module.exports = __webpack_public_path__ + "static/mx-series-brochure-3514e5008aeb8bc1a16a2978f79ba3f3.pdf";